export default {
    data() {
        return {

        }
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/banner-btn-questionnaires/component.js